import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getItem } from "./Auth/localStorageService";
import { store } from "./Store/store";
import i18n from "i18next";
import { languageKey } from "./components/LanguageSelector/LanguageSelectorConstant";
import translationEN from "./locales/en/translation.json";
import translationSP from "./locales/es/translation.json";

const getBrowserLanguage = () => {
  if (typeof navigator === "undefined") return languageKey.en;
  const lang = navigator.language || "";
  return lang.startsWith("es") ? languageKey.sp : languageKey.en;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    lng: getItem("language") || getBrowserLanguage(),
    fallbackLng: languageKey.en,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: translationEN,
      },
      es: {
        translation: translationSP,
      },
    },
  });

let currentLanguage = i18n.language;
store.subscribe(() => {
  const state = store.getState();
  const language = state.languageChange.language;
  if (language && language !== currentLanguage) {
    i18n.changeLanguage(language);
    currentLanguage = language;
  }
});

export default i18n;
